<template>
    <div :class="classes">

        <svg fill="currentColor" :class="iconClasses || 'h-5 w-5'" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path
                    d="M5.755,20.283,4,8H20L18.245,20.283A2,2,0,0,1,16.265,22H7.735A2,2,0,0,1,5.755,20.283ZM21,4H16V3a1,1,0,0,0-1-1H9A1,1,0,0,0,8,3V4H3A1,1,0,0,0,3,6H21a1,1,0,0,0,0-2Z">
                </path>
            </g>
        </svg>

    </div>
</template>

<script>
export default {
    name: "GaleryIcon",
    props: {
        fill: {
            type: String,
            default: "currentColor",
        },
        classes: {
            type: String,
            default: "",
        },
        iconClasses: {
            type: String,
            default: "",
        },
    },
}

</script>